const heartStates = {
    ON: 'on',
    OFF: 'off'
};

export default function heart({ $element, ids, onChange }) {
    const id = +$element.dataset.id;

    if (ids.includes(id)) {
        $element.dataset.heart = heartStates.ON;
    }

    const toggle = $element => {
        const isOn = $element.dataset.heart === heartStates.ON;
        const state = isOn ? heartStates.OFF : heartStates.ON;
        const label = isOn ? 'Remove item from wishlist' : 'Add item to wishlist';
        $element.dataset.heart = state;
        $element.setAttribute('aria-label', label);
        return state;
    };

    const setDisabledState = isDisabled => $element.disabled = isDisabled;

    $element.addEventListener('click', (e) => {
        e.stopPropagation();

        const state = toggle($element);

        if (typeof onChange !== 'function') {
            return;
        }

        onChange({
            id,
            active: state === heartStates.ON,
            enable: () => setDisabledState(false),
            disable: () => setDisabledState(true),
            $element
        });
    });
}